import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CategoryPageContainer, LandingPageContainer } from '@ori/editorial-category';
import { EditorialPageContainer } from '@ori/editorial-page';
import { Layout } from '~/containers/Layout';
const Page = (param)=>{
    let { layoutPage, props, type } = param;
    const { breadcrumbs } = props;
    if (type === 'category') {
        const { data, preview } = props;
        return /*#__PURE__*/ _jsx(Layout, {
            layoutPage: layoutPage,
            children: /*#__PURE__*/ _jsx(CategoryPageContainer, {
                breadcrumbs: breadcrumbs,
                data: data,
                preview: preview
            })
        });
    } else if (type === 'page') {
        const { data, productBoxConfiguration, preview } = props;
        return /*#__PURE__*/ _jsx(Layout, {
            layoutPage: layoutPage,
            children: /*#__PURE__*/ _jsx(EditorialPageContainer, {
                breadcrumbs: breadcrumbs,
                data: data,
                productBoxConfiguration: productBoxConfiguration,
                preview: preview
            })
        });
    }
    const { data } = props;
    return /*#__PURE__*/ _jsx(Layout, {
        layoutPage: layoutPage,
        children: /*#__PURE__*/ _jsx(LandingPageContainer, {
            breadcrumbs: breadcrumbs,
            data: data
        })
    });
};
export var __N_SSG = true;
export default Page;
